import { Capacitor, registerPlugin } from "@capacitor/core";
import { api } from "./api";

// Bridge to the native StoreKit 2 plugin (iOS only). On web this is never used — web keeps Stripe.
const AppleIAP = registerPlugin("AppleIAP");

export const APPLE_PRODUCT_ID = "com.molaroo.app.premium.monthly";

export function appleIapAvailable() {
  return Capacitor.getPlatform() === "ios";
}

// Full native purchase flow: fetch the per-user account token, present the StoreKit 2 sheet,
// then hand Apple's signed transaction (JWS) to our backend for server-side verification.
export async function purchaseApplePremium() {
  const { data } = await api.get("/iap/apple/account-token");
  if (!data?.configured) {
    throw new Error("Apple purchases are not available right now. Please try again later.");
  }
  const result = await AppleIAP.purchase({
    productId: data.product_id || APPLE_PRODUCT_ID,
    appAccountToken: data.app_account_token,
  });
  const verify = await api.post("/iap/apple/transactions", {
    signedTransaction: result.jwsRepresentation,
  });
  return verify.data; // { verified, billing }
}

// Apple's live product info: localized price + this Apple Account's intro-offer eligibility.
export async function getAppleProductInfo() {
  try {
    return await AppleIAP.getProduct({ productId: APPLE_PRODUCT_ID });
  } catch {
    return null;
  }
}

// Re-sync with the App Store and send each current entitlement to the backend for verification.
export async function restoreApplePurchases() {
  const { transactions = [] } = (await AppleIAP.restore()) || {};
  let restored = 0;
  for (const jws of transactions) {
    const { data } = await api.post("/iap/apple/transactions", { signedTransaction: jws });
    if (data?.verified && data?.billing?.premium) restored += 1;
  }
  return restored;
}

export async function manageAppleSubscriptions() {
  await AppleIAP.manageSubscriptions();
}
